export const PCAs = [
    {
        "name": "Danielle Colon",
        "email": "dfc5@rice.edu",
        "year": "Junior",
        "areaOfStudy": "Cognitive Sciences"   
    },
    {
        "name": "Christina Ko",
        "email": "cyk3@rice.edu",
        "year": "Senior",
        "areaOfStudy": "Neuroscience"
    },
    {
        "name": "Yuna Jiang",
        "email": "yj65@rice.edu",
        "year": "Sophomore",
        "areaOfStudy": "Business and Managerial Economics and Organizational Sciences"
    },
]
